export const mutationsTypes = {
  SET_PRODUCT: "SET_PRODUCT"
};

export const actionsTypes = {
  setProduct: "setProduct"
};
